<template>
  <div id="user-view">
    <div class="l-columns-container l-columns-container--outmost">
      <div class="l-tablet-column--6">
        <h1 class="f-headline">
          <strong>Køb</strong> køb køb
        </h1>

        <div class="l-columns-container">
          <div class="l-laptop-column--8">
            <div class="f-text">
              <p>Man skal have en bruger før man kan købe.</p>
              <p>Et medlemskab koster 59,-</p>
            </div>
            
            <div class="c-text__cta">
              <ArrowLink
                url="#0"
                title="Bliv medlem"
                @click="startSubscription()"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="l-tablet-column--6">
        <img
          src="@/assets/hero.png"
          class="c-about__image"
        >
      </div>
    </div>
  </div>
</template>

<script>
import ArrowLink from "@/components/ArrowLink.vue";

export default {
  components: {
    ArrowLink
  }
}
</script>

<style scoped lang="scss">
</style>